import { useQuery } from '@apollo/client';

import { EventProduct, getUpcomingDeliveryEventDetails } from '@/api';

import { DeliveryEventVendorDetailsUpcoming } from '../types';
import { parseEventVendorIds, sumSummaryField } from '../helpers';

type UseDeliveryUpcomingEvent = {
  event: DeliveryEventVendorDetailsUpcoming | undefined;
  itemCount: number | null;
  loading: boolean;
};

// Only the item count spans the manifest. Manifest documents, vendor-level
// capacity and the order-preview URL are shared by every member, so the first
// one is representative for those.
export const useDeliveryUpcomingEvent = (id: string): UseDeliveryUpcomingEvent => {
  const requestedIds = parseEventVendorIds(id);

  const { data, loading } = useQuery(getUpcomingDeliveryEventDetails, {
    variables: { input: { eventVendorIds: requestedIds, productType: EventProduct.DELIVERY } },
  });

  const members = data?.getEventVendors?.eventVendors as
    | DeliveryEventVendorDetailsUpcoming[]
    | undefined;

  return {
    event: members?.[0],
    itemCount:
      members?.length === requestedIds.length ? sumSummaryField(members, 'summaryItemCount') : null,
    loading,
  };
};
